// extracted by mini-css-extract-plugin
export var categories = "navigationCategorySelection-module--categories--33297";
export var categoryButtonHidden = "navigationCategorySelection-module--categoryButtonHidden--6e02d";
export var contentContainer = "navigationCategorySelection-module--contentContainer--6d97d";
export var customTertiary = "navigationCategorySelection-module--customTertiary--b1a7e";
export var displayCategoryButton = "navigationCategorySelection-module--displayCategoryButton--71e8a";
export var headline = "navigationCategorySelection-module--headline--37afe";
export var hideCategories = "navigationCategorySelection-module--hideCategories--3b371";
export var isExpanded = "navigationCategorySelection-module--isExpanded--63a5b";
export var showCategories = "navigationCategorySelection-module--showCategories--89ca9";
export var styledIcon = "navigationCategorySelection-module--styledIcon--0189c";
export var wrapperStyle = "navigationCategorySelection-module--wrapperStyle--95639";